import React, { useEffect } from "react"
import { useParams } from "react-router-dom"
import { useCall } from "context/CallContext"
import VideoChat from "./VideoChat"

const VideoChatRoute = () => {
  const { videoId } = useParams()
  const { channelName, setChannelName, joined, setIsPiP } = useCall()

  useEffect(() => {
    if (videoId && channelName !== videoId) {
      setChannelName(videoId)
    }
  }, [videoId, channelName, setChannelName])

  useEffect(() => {
    if (joined) {
      setIsPiP(false)
    }
  }, [joined, setIsPiP])

  return (
    <div className="video-container video-container--full">
      <VideoChat />
    </div>
  )
}

export default VideoChatRoute
